import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';

const TableSkeleton = ({ rows = 8, columns = 6, rowHeight = 52, title }) => {
  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      {title && (
        <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 1 }}>
          {title}
        </Typography>
      )}

      <Box sx={{
        width: '100%',
        flex: 1,
        border: '1px solid #e0e0e0',
        borderRadius: 1,
        overflow: 'hidden',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Header Skeleton */}
        <Box sx={{ display: 'flex', borderBottom: '1px solid #e0e0e0', p: 1.5, gap: 2 }}>
          {Array.from({ length: columns }).map((_, i) => (
            <Skeleton key={i} variant="text" height={24} sx={{ flex: 1, transform: 'none' }} />
          ))}
        </Box>

        {/* Rows Skeleton */}
        <Box sx={{ width: '100%', flex: 1 }}>
          {Array.from({ length: rows }).map((_, i) => (
            <Box key={i} sx={{ display: 'flex', gap: 2, p: 1.5, height: `${rowHeight}px`, alignItems: 'center', borderBottom: i < rows - 1 ? '1px solid #f0f0f0' : 'none' }}>
              {Array.from({ length: columns }).map((__, j) => (
                <Skeleton
                  key={j}
                  variant="rectangular"
                  height={rowHeight - 16}
                  sx={{ flex: 1, borderRadius: 1 }}
                />
              ))}
            </Box>
          ))}
        </Box>

        {/* Footer Skeleton */}
        <Box sx={{ borderTop: '1px solid #e0e0e0', p: 1.5, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Skeleton variant="text" width={200} height={20} sx={{ transform: 'none' }} />
        </Box>
      </Box>
    </Box>
  );
};

export default TableSkeleton;

